import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { originDataEnumEmailPerAd } from "../../constants/idOriginAsistance";

@Component({
  selector: "app-modal-register-guest-attendance",
  templateUrl: "./modal-register-guest-attendance.component.html",
  styleUrls: ["./modal-register-guest-attendance.component.css"],
})
export class ModalRegisterGuestAttendanceComponent implements OnInit {
  @Input() allowPersonNumber: boolean = true;
  @Input() allowCurp: boolean = true;

  @Output() submitData = new EventEmitter<{
    type: originDataEnumEmailPerAd;
    value: string;
  }>();
  @Output() closeModal = new EventEmitter<void>();

  inputText = "";
  isValidInputForm = false;
  isFormGuestNumberPerson = true;

  get showToggle(): boolean {
    return this.allowCurp && this.allowPersonNumber;
  }

  ngOnInit() {
    // Determinar modo inicial
    if (!this.allowPersonNumber && this.allowCurp) {
      this.isFormGuestNumberPerson = false;
    }
  }

  get buttonText(): string {
    return this.isFormGuestNumberPerson
      ? "Ingresar por CURP"
      : "Ingresar por número de persona";
  }

  regexValidation() {
    if (this.isFormGuestNumberPerson) {
      const pattern = /^\d{8}$/;
      this.isValidInputForm = pattern.test(this.inputText);
      return;
    }
    const pattern = /^[A-Z]{4}\d{6}[HM][A-Z]{2}[A-Z]{3}[0-9A-Z]\d$/;
    this.isValidInputForm = pattern.test(this.inputText);
  }

  submit() {
    if (!this.isValidInputForm) {
      return;
    }

    this.submitData.emit({
      type: this.isFormGuestNumberPerson
        ? originDataEnumEmailPerAd.personNumber
        : originDataEnumEmailPerAd.curp,
      value: this.inputText,
    });
  }

  changeForm() {
    if (!this.showToggle) {
      return;
    }

    this.isFormGuestNumberPerson = !this.isFormGuestNumberPerson;
    this.cleanInput();
  }

  cleanInput() {
    this.inputText = "";
    this.isValidInputForm = false;
  }

  onCloseModal() {
    this.cleanInput();
    this.closeModal.emit();
  }
}
